export default function initResultadosProdutosSlider() {
    const swiperContainer = document.querySelector('.search .c-search-products__swiper');

    if (!swiperContainer) return;

    const resultadosProdutosSwiper = new Swiper(swiperContainer, {

        slidesPerView: 1.4,
        spaceBetween: 15,
        grabCursor: true,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,

        a11y: {
            enabled: true,
            prevSlideMessage: 'Slide anterior',
            nextSlideMessage: 'Próximo slide',
            firstSlideMessage: 'Este é o primeiro slide',
            lastSlideMessage: 'Este é o último slide',
            paginationBulletMessage: 'Ir para o slide {{index}}',
        },

        navigation: {
            nextEl: '.search .c-search-products__arrow--next.js-search-next',
            prevEl: '.search .c-search-products__arrow--prev.js-search-prev',
        },

        pagination: {
            el: '.search .c-search-products__pagination.swiper-pagination',
            clickable: true,
        },

        breakpoints: {
            992: {
                slidesPerView: 3.4,
                spaceBetween: 20,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            }
        }
    });

    return resultadosProdutosSwiper;
}